import React, { useEffect, useState,useRef } from 'react'
import bigStar from './assets/bigstar.png'
import instagram from './assets/instagram.png'
import fullStar from './assets/fullStar.svg'
import emptyStar from './assets/emptyStar.svg'
import { RiThumbUpLine } from "react-icons/ri";
import { RiThumbDownLine } from "react-icons/ri";
import baseUrl from '../baseUrl'
import axios from 'axios'
// import { FaArrowUp } from 'react-icons/fa';
import arrowUp from '../assets/arrowUp.svg'


const formattedDate = (date) => {
    const eventDate = new Date(date);
    const day = eventDate.getDate();
    const suffix = ["th", "st", "nd", "rd"][(day % 10 > 3 || [11, 12, 13].includes(day % 100)) ? 0 : day % 10];

    const newDateVersion = `${day}${suffix} ${eventDate.toLocaleDateString('en-GB', {
        month: 'long',
        year: 'numeric',
    })}`;

    return newDateVersion;
};


const Review = ({ accessToken, user, item, setCreateAccount, page }) => {
    const [thumpsUp, setThumpsUp] = useState(0)
    const [thumpsDown, setThumpsDown] = useState(0)
    const [thumbsUpIds, setThumbsUpIds] = useState({});
    const [thumbsDownIds, setThumbsDownIds] = useState({});
    // State to manage the 'read more' toggle
    const [isTruncated, setIsTruncated] = useState(true);
    const [likeId, setLikedId] = useState()
    const [showScroll, setShowScroll] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef(null);


    const vendor = item?.vendor
    const likes = vendor?.likes
    const ratingScore = item?.rating?.rating_score
    const reviewer = item?.user
    const vendorOwner = item?.vendor?.user
    const comments = item?.comments[0]
    const event = comments?.event

    const threeWords = item?.three_words?.split(",")?.map(word => word?.trim())?.filter(word => word !== ""); // Remove empty strings
    // Full text to display
    const fullText = comments?.comment || '';
    // Set a character limit for truncation
    const [charLimit, setCharLimit] = useState(170);


    const truncate = (text, limit = 9) => {
        return text?.length > limit ? text.slice(0, limit) + "..." : text;
    };


    useEffect(() => {
        const updateCharLimit = () => {
            if (window.innerWidth < 1024) {
                setCharLimit(100); // For screens below XL
            } else {
                setCharLimit(120); // For XL and above
            }
        };

        updateCharLimit(); // Set initial limit
        window.addEventListener("resize", updateCharLimit);

        return () => window.removeEventListener("resize", updateCharLimit);
    }, []);
    // Handler for the 'read more' button
    const handleReadMore = () => {
        setIsTruncated(!isTruncated);
    };
    // Determine which text to display
    let displayText = fullText

    if (displayText.length > charLimit) {
        displayText = isTruncated ? fullText.slice(0, charLimit) + '...' : fullText;
    }

    if (formattedDate(comments?.event_date) === "Invalid Date") {
        // console.log(item)
    }

    const calculateLikes = (vendorLikes) => {
        if (vendorLikes?.length > 0) {
            const thumbsUpDict = {};
            const thumbsDownDict = {};

            vendorLikes.forEach(like => {
                if (like.user_id === user?.user_id && like.comment_id === comments?.comment_id) {
                    setLikedId(like.like_id);  // Store like ID for this specific comment
                }
                if (like.thumbs_up && like.comment_id === comments?.comment_id) {
                    thumbsUpDict[like.user_id] = like.like_id; // Store thumbs up per comment
                }
                if (like.thumbs_down && like.comment_id === comments?.comment_id) {
                    thumbsDownDict[like.user_id] = like.like_id; // Store thumbs down per comment
                }
            });

            setThumbsUpIds(thumbsUpDict);
            setThumbsDownIds(thumbsDownDict);
        }
    };



    const handleThumbsUp = async () => {
        if (!user) {
            setCreateAccount(1);
            return;
        }

        let updatedLikeId = likeId; // Store the latest like ID

        if (thumbsUpIds.hasOwnProperty(user?.user_id)) {
            // User already liked, so remove it
            await removeLike(thumbsUpIds[user?.user_id]);
            setThumbsUpIds(prev => {
                const updated = { ...prev };
                delete updated[user?.user_id];
                return updated;
            });
            setThumpsUp(prev => Math.max(0, prev - 1));
            return;
        }

        const data = JSON.stringify({
            thumbs_up: true,
            thumbs_down: false,
            user_id: user?.user_id,
            vendor_id: vendor?.vendor_id,
            comment_id: comments?.comment_id // Ensure comment_id is sent correctly
        });

        let config = {};

        if (thumbsDownIds.hasOwnProperty(user?.user_id)) {
            updatedLikeId = thumbsDownIds[user?.user_id]; // Get the like ID from thumbsDownIds
            config = {
                method: 'put',
                url: `${baseUrl}/like/${updatedLikeId}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${JSON.parse(accessToken)}`
                },
                data: data
            };
        } else {
            config = {
                method: 'post',
                url: `${baseUrl}/like`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${JSON.parse(accessToken)}`
                },
                data: data
            };
        }

        try {
            const response = await axios.request(config);
            const newLikeId = response.data.like_id || updatedLikeId;
            setLikedId(newLikeId); // Ensure like ID is set

            setThumbsUpIds(prev => ({ ...prev, [user?.user_id]: newLikeId }));
            setThumbsDownIds(prev => {
                const updated = { ...prev };
                delete updated[user?.user_id];
                return updated;
            });

            // Correctly update the count after the state changes
            setThumpsUp(prev => prev + 1);
            setThumpsDown(prev => Math.max(0, prev - 1));

        } catch (error) {
            console.error("Error handling thumbs up:", error);
        }
    };


    const handleThumbsDown = async () => {
        if (!user) {
            setCreateAccount(1);
            return;
        }

        let updatedLikeId = likeId; // Store the latest like ID

        if (thumbsDownIds.hasOwnProperty(user?.user_id)) {
            // User already disliked, so remove it
            await removeLike(thumbsDownIds[user?.user_id]);
            setThumbsDownIds(prev => {
                const updated = { ...prev };
                delete updated[user?.user_id];
                return updated;
            });
            setThumpsDown(prev => Math.max(0, prev - 1));
            return;
        }

        const data = JSON.stringify({
            thumbs_up: false,
            thumbs_down: true,
            user_id: user?.user_id,
            vendor_id: vendor?.vendor_id,
            comment_id: comments?.comment_id // Ensure comment_id is sent correctly
        });

        let config = {};

        if (thumbsUpIds.hasOwnProperty(user?.user_id)) {
            updatedLikeId = thumbsUpIds[user?.user_id]; // Get the like ID from thumbsUpIds
            config = {
                method: 'put',
                url: `${baseUrl}/like/${updatedLikeId}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${JSON.parse(accessToken)}`
                },
                data: data
            };
        } else {
            config = {
                method: 'post',
                url: `${baseUrl}/like`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${JSON.parse(accessToken)}`
                },
                data: data
            };
        }

        try {
            const response = await axios.request(config);
            const newLikeId = response.data.like_id || updatedLikeId;
            setLikedId(newLikeId); // Ensure like ID is set

            setThumbsDownIds(prev => ({ ...prev, [user?.user_id]: newLikeId }));
            setThumbsUpIds(prev => {
                const updated = { ...prev };
                delete updated[user?.user_id];
                return updated;
            });

            // Correctly update the count after the state changes
            setThumpsDown(prev => prev + 1);
            setThumpsUp(prev => Math.max(0, prev - 1));

        } catch (error) {
            console.error("Error handling thumbs down:", error);
        }
    };

    const removeLike = async (likeId) => {
        try {
            await axios.delete(`${baseUrl}/like/${likeId}/remove`, {
                headers: {
                    'Authorization': `Bearer ${JSON.parse(accessToken)}`
                }
            });
        } catch (error) {
            console.error("Error removing like:", error);
            //handleAuthError(error);
        }
    };

    useEffect(() => {
        calculateLikes(likes);
    }, [likes]);

    useEffect(() => {
        // Set the thumb counts based on the dictionaries
        setThumpsUp(Object.keys(thumbsUpIds).length);
        setThumpsDown(Object.keys(thumbsDownIds).length);
    }, [thumbsUpIds, thumbsDownIds]);



    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    useEffect(() => {
        if (textRef.current) {
          const el = textRef.current;
          setIsOverflowing(el.scrollHeight > el.clientHeight);
        }
      }, [fullText]);

    return (
        <div className={` ${page === 'vendor' ? 'h-[317px] mg:h-[328px] xl:h-[350px] pb-[30px]' : 'h-[400px] mg:h-[430px] xl:h-[450px]  '} w-full  flex flex-col justify-between pt-[23px] xl:pt-[30px] rounded-[30px] border border-[1px] border-[#C1C1C1] border-opacity-50 shadow-review`}>
            {showScroll && (
                <button
                    onClick={scrollToTop}
                    className="fixed bottom-8 right-6 md:right-8 xl:right-[104px] bg-backtop text-white  p-4 lg:p-6 rounded-full hover:bg-blue-700 transition"
                >
                    <img src={arrowUp} />
                </button>
            )}


            {/**Info */}
            <div className='w-full px-[15px] sm:px-2 xl:px-[21px]  flex flex-col'>
                <div className='flex gap-[8px] flex-wrap sm:flex-nowrap items-center text-xs px-[10px]'>
                    <div className=' px-[10px] h-[26px] rounded-[5px] flex items-center justify-center text-center  font-bold  bg-[#0079FF] text-white'>{event?.event_name}</div>

                    {
                        formattedDate(comments?.event_date) === "Invalid Date" ? null :
                            <h1 className='text-[#AAAAAA] '><span className=' font-bold'>Event date: </span>{formattedDate(comments?.event_date)}</h1>
                    }
                </div>

                {/**User on vendor page*/}
                {page === 'vendor' && (
                    <div className='px-[10px] mt-[17px]  w-full  flex items-center justify-between '>
                        <div className='flex flex-col'>
                            <h1 className=' font-bold text-base lg:text-sm text-black'>{reviewer?.first_name} {reviewer?.last_name}<span className='text-base text-ravinput font-normal'> rated </span> </h1>
                            {/* Stars */}
                            <div className='mt-[5px] flex gap-[2.14px] items-center'>
                                {/** Full Stars */}
                                {[...Array(ratingScore)]?.map((_, index) => (
                                    <img key={index} src={fullStar} alt="fullStar" className='w-[15.28px] h-[14.54px]' />
                                ))}
                                {/** Empty Stars */}
                                {[...Array(5 - ratingScore)]?.map((_, index) => (
                                    <img key={index} src={emptyStar} alt="emptyStar" className='w-[15.28px] h-[14.54px]' />
                                ))}
                            </div>
                        </div>
                        <div className='flex gap-[7px] items-center'>
                            <div className='flex gap-[7px] items-center text-center'>
                                <RiThumbUpLine
                                    onClick={() => handleThumbsUp()}
                                    className={` ${thumbsUpIds?.hasOwnProperty(user?.user_id) ? "text-[#2D8EF7] cursor-pointer" : "text-[#C1C1C1] hover:text-[#2D8EF7] cursor-pointer"} w-[21px] h-[20px]`}
                                />
                                <h1 className=' font-bold text-sm text-black '>{thumpsUp}</h1>
                            </div>
                            <div className='flex gap-[7px] items-center text-center'>
                                <RiThumbDownLine
                                    onClick={() => handleThumbsDown()}
                                    className={` ${thumbsDownIds?.hasOwnProperty(user?.user_id) ? "text-[#F95062] cursor-pointer" : "text-[#C1C1C1] hover:text-[#F95062] cursor-pointer"} w-[21px] h-[20px]`}
                                />
                                <h1 className=' font-bold text-sm text-black '>{thumpsDown}</h1>
                            </div>
                        </div>
                    </div>)}

                <div className={`${page === 'vendor' ? 'hidden' : 'block'} mt-[25px] w-full flex items-start gap-[10px] justify-between`}>
                    {/* Content container */}


                    <div className='flex flex-col w-full gap-[2px]'>
                        <div className='flex justify-between gap-1'>

                            <div className='flex '>
                                {ratingScore == 5 && (<img src={bigStar} alt="bigStar" className='ml-[10px] w-[23px] h-[32px] shrink-0' />)}
                                <div className='px-[10px]'>

                                    <h1
                                        className=' whitespace-nowrap font-bold text-[18px] text-black max-w-[130px]'
                                    // style={{
                                    //     overflowX: 'auto', // Enable horizontal scrolling
                                    //     WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
                                    //     scrollbarWidth: 'none', // Firefox-specific to hide the scrollbar
                                    // }}
                                    >
                                        {truncate(vendor?.vendor_name, 12)}
                                    </h1>
                                    <p className='text-xs  text-black'>{vendor?.category?.category_name}</p>

                                    {/* Stars */}
                                    <div className='mt-[2px] flex gap-[2.14px] items-center shrink-0'>
                                        {/** Full Stars */}
                                        {[...Array(ratingScore)]?.map((_, index) => (
                                            <img key={index} src={fullStar} alt="fullStar" className='w-[15.28px] h-[14.54px]' />
                                        ))}
                                        {/** Empty Stars */}
                                        {[...Array(5 - ratingScore)]?.map((_, index) => (
                                            <img key={index} src={emptyStar} alt="emptyStar" className='w-[18.33px] h-[18.33px]' />
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center h-[38px] gap-[8px] -mt-1">
                                <a href={vendor?.vendor_address} target="_blank" rel="noopener noreferrer" className="text-[#AAAAAA] text-[14px] font-medium whitespace-nowrap " > Visit Page </a>
                                <a href={vendor?.vendor_address} target="_blank" rel="noopener noreferrer" className="w-[28px]"> <img src={instagram} alt="instagram" className="w-[28px] h-[28px]" /></a>
                            </div>
                        </div>


                    </div>



                </div>

                {/**The three words */}
                <div className=' px-1 mt-[22px] w-full flex flex-nowrap  sm:gap-1 gap-2 justify-start'>
                    {
                        threeWords?.length > 0 ?
                            threeWords?.map((text, index) => {
                                return (
                                    <div key={index} className=' min-w-[88px] mg:min-w-[100px] h-[25px] flex items-center justify-center rounded-[30px] px-2 font-bold text-[12px] text-black leading-[16.2px] border-[2px] border-black'>{text}</div>
                                )
                            })
                            : null
                    }
                </div>
                {/**More details */}
                <div className="w-full px-[10px] mt-[10px]">
  {fullText && (
    <>
      <div
        ref={textRef}
        className={`text-base text-black transition-all duration-300
          ${expanded ? "max-h-[4.5em] overflow-y-auto" : "line-clamp-3"}
        `}
        style={{ lineHeight: "1.5em" }}
      >
        {fullText}
      </div>

      {isOverflowing && (
        <button
          onClick={() => setExpanded(prev => !prev)}
          className="mt-1 text-left font-bold text-base text-[#0079FF]"
        >
          {expanded ? "read less" : "read more"}
        </button>
      )}
    </>
  )}
</div>

                {/* <div className="relative w-full px-[10px]">

                    {
                        displayText?.length > 0 ?
                            <div className={`mt-[10px] w-[271px] xl:min-w-[370px] h-[57px] overflow-y-auto overflow-x-hidden `}
                                style={{
                                    overflowX: 'auto',
                                    WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
                                    scrollbarWidth: 'thin',  // Firefox-specific for thin scrollbar
                                    scrollbarColor: '#C1C1C1 #E5E5E5', // Firefox-specific for thumb and track colors
                                }}

                            >
                                <p className='text-base text-black '>
                                    {displayText}
                                </p>

                            </div>
                            : null
                    }
                    Conditionally render the 'read more' button 
                    {isTruncated && fullText?.length > charLimit && (
                        <button
                            onClick={handleReadMore}
                            className=' w-full mt-0 flex items-start justify-start text-start font-bold text-base  text-[#0079FF] '
                        >
                            read more
                        </button>
                    )}
                    {!isTruncated && (
                        <button
                            onClick={handleReadMore}
                            className='w-full flex items-start justify-start text-start font-bold text-base text-[#0079FF] '
                        >
                            see less
                        </button>
                    )}
                </div> */}


            </div>
            <div>
                {/**Feedback */}
                <div className=' mt-[0px] lg:mt-[0px] flex gap-[11px] px-[10px] mx-[15px] sm:mx-[10px] xl:mx-[21px] '>
                    <div className='flex gap-[7px] items-center'>
                        <p className=' font-bold text-xs text-black '>HIRE AGAIN</p>
                        {item?.hire_again === true ?
                            <div className=' w-[40px] h-[20px] rounded-[5px] flex items-center justify-center text-center font-black text-[10px] text-white leading-[13.5px] bg-[#4FBF26]'>YES</div>
                            :
                            <div className=' w-[40px] h-[20px] rounded-[5px] flex items-center justify-center text-center font-black text-[10px] text-white leading-[13.5px] bg-[#F32424]'>NO</div>

                        }                    </div>

                    <div className='flex gap-[7px] items-center'>
                        <p className=' font-bold text-xs text-black '>RECOMMEND</p>
                        {
                            item?.recommend_again === true ? <div className=' w-[40px] h-[20px] rounded-[5px] flex items-center justify-center text-center font-black text-[10px] text-white leading-[13.5px] bg-[#4FBF26]'>YES</div>
                                :
                                <div className=' w-[40px] h-[20px] rounded-[5px] flex items-center justify-center text-center font-black text-[10px] text-white leading-[13.5px] bg-[#F32424]'>NO</div>
                        }
                    </div>
                </div>

                {/**User on other pages*/}
                {page != 'vendor' && (
                    <div className='h-[68px] mg:h-[86px] mt-[18px] xl:mt-[28px]  xl:mt-[49px] pt-[10px] pb-[10px] px-[25px] lg:px-[21px] xl:px-[30px] w-full rounded-b-[30px] flex items-center justify-between bg-[#E5E5E580]'>
                        <div className='flex flex-col'>
                            <h1 className=' font-bold text-base lg:text-sm text-black'>{reviewer?.first_name} {reviewer?.last_name}</h1>
                            <p className=' text-xs text-[#707070] flex items-center gap-[4px]'>gave this vendor a <img src={fullStar} alt='star' className='size-[14px]' /><span className=' text-black font-black flex '> {ratingScore}.0 </span> rating</p>
                        </div>
                        <div className='flex gap-[7px] items-center'>
                            <div className='flex gap-[7px] items-center text-center'>
                                <RiThumbUpLine
                                    onClick={() => handleThumbsUp()}
                                    className={` ${thumbsUpIds?.hasOwnProperty(user?.user_id) ? "text-[#2D8EF7] cursor-pointer" : "text-[#C1C1C1] hover:text-[#2D8EF7] cursor-pointer"} w-[21px] h-[20px]`}
                                />
                                <h1 className=' font-bold text-sm text-black '>{thumpsUp}</h1>
                            </div>
                            <div className='flex gap-[7px] items-center text-center'>
                                <RiThumbDownLine
                                    onClick={() => handleThumbsDown()}
                                    className={` ${thumbsDownIds?.hasOwnProperty(user?.user_id) ? "text-[#F95062] cursor-pointer" : "text-[#C1C1C1] hover:text-[#F95062] cursor-pointer"} w-[21px] h-[20px]`}
                                />
                                <h1 className=' font-bold text-sm text-black '>{thumpsDown}</h1>
                            </div>
                        </div>
                    </div>)}
            </div>
        </div>
    )
}

export default Review
